import { UPDATE_SELECT_BASIC_PLAN } from 'quick-quote/product-common/coverage-plan/actions'
import { reducer as identity } from '../identity'
import { combineReducers } from 'redux'
import { get } from 'lodash'
import { set } from 'lodash/fp'
import { reducer as entryComponent } from 'quick-quote/entry-component/reducer'
import { reducer as insured } from 'quick-quote/insured-information'
import { reducer as ui } from 'quick-quote/ui'
import { reducer as benefitIllustration } from 'quick-quote/product-whole-life/benefit-illustration/reducer'
import { reducer as coveragePlan } from 'quick-quote/product-common/coverage-plan'
import { reducer as investment } from 'quick-quote/product-investment'
import { reducer as permissionOrdinary } from 'quick-quote/product-common'
import { reducer as notificationMessage } from 'quick-quote/notification'
import { reducer as loan } from 'quick-quote/product-loan/redux'
import { reducer as fna } from 'quick-quote/fna'
import { reducer as portal } from 'quick-quote/portal'

import { appVersion } from 'core/reducers'
import constants from 'core/data-model/constants/defaults'

import { SF_REFERENCE, ENTERING_IPRO } from 'quick-quote/opty/actions'

import {
  SELECT_PRODUCT,
  SELECT_PRODUCT_CATEGORY,
  AVAILABLE_PLAN_CODE,
  AVAILABLE_PRODUCT_CATEGORIES,
  CHANGE_PRODUCT,
} from 'quick-quote/product-selection/actions'
import { SELECT_BASIC_PLAN } from 'quick-quote/product-health/coverage-plan/actions'

import { IHEALTHY_ULTRA_SELECT_BASIC_PLAN } from 'quick-quote/product-ihealthy-ultra/coverage-plan/actions'

import { EDIT_PERFECT_LIFE_PLAN } from 'quick-quote/product-perfect-life/coverage-plan/actions'
import { EDIT_CAMPAIGN_PLAN } from 'quick-quote/product-sukhapabdekdee/actions'
import {
  MRTA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT,
  MRTA_UPDATE_COVERAGE_PERIOD_IN_SELECTED_DISPLAY_PRODUCT,
} from 'quick-quote/product-mrta/actions'

import {
  APP_FAILED_SECURITY_POLICY,
  CONNECT_TO_DATABASE_FAILED,
  CONNECT_TO_DATABASE_REQUEST,
  CONNECT_TO_DATABASE_SUCCESS,
  GENERATE_PDF_FAILURE,
  GENERATE_PDF_REQUEST,
  GENERATE_PDF_SUCCESS,
  GET_MODEL_FACTORS_FAILED,
  GET_MODEL_FACTORS_REQUEST,
  GET_MODEL_FACTORS_SUCCESS,
  GET_OCCUPATIONS_FAILED,
  GET_OCCUPATIONS_REQUEST,
  GET_OCCUPATIONS_SUCCESS,
  GET_PRODUCTS_FAILED,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_RIDERS_FAILED,
  GET_RIDERS_REQUEST,
  GET_RIDERS_SUCCESS,
  INITIALISE_APPLICATION_FAILED_WITH_NO_INTERNET,
  INITIALISE_APPLICATION_FAILED_WITH_UPDATE_APP,
  INITIALISE_APPLICATION_FAILED_WITH_UPDATE_DATABASE,
  INITIALISE_APPLICATION_REQUEST,
  INITIALISE_APPLICATION_SERVER_IS_DOWN,
  INITIALISE_APPLICATION_SUCCESS,
  PROCESSING_APP_DATA_REQUEST,
  PROCESSING_APP_DATA_SUCCESS,
  PROCESSING_APP_DATA_UNSET,
  SET_ALLOWED_AGENT_TYPES,
  SET_VERSION,
  SET_VIEW_CONFIGURATION,
  SET_FNA_CONFIGURATION,
  RESET_QUOTE_FORM,
  RESET_DISPLAY_PRODUCT,
  PATCH_PRODUCTS_SUCCESS,
  CLONE_APP_LIST,
  CLEAR_CLONE_APP_LIST,
  SET_CLONE_APP_ID,
  SET_CLONED_POLICY,
  CLONE_APP_SEARCH_STATUS,
  CLEAR_CLONE_APP_SEARCH_STATUS,
  SET_ENABLE_MA_PAGE,
  SET_ENABLE_RETRIEVE_CUSTOMER_POLICY,
} from './actions'
import {
  GET_DISTRIBUTOR_GROUPS_FAILED,
  GET_DISTRIBUTOR_GROUPS_REQUEST,
  GET_DISTRIBUTOR_GROUPS_SUCCESS,
} from 'identity/actions'

import {
  SALE_PERMISSION_VALIDATION_COMPLETED,
  VALIDATING_SALE_PERMISSION,
} from 'quick-quote/product-investment/validate-permission/actions'
import { UPDATE_WEALTH_SOURCE_DATA, INIT_CUSTOMER_PROFILE } from './my-wealth-plus/actions'

const initVersionState = {
  appVersion: '',
  fetching: false,
  installing: false,
  error: null,
}
const initAllowedAgentTypes = []
const initViewConfigurationState = {
  productList: [],
}
const initFnaConfigurationState = {
  needCategoryList: [],
  marketConductsQuestionnaires: {
    insuranceQuestion: [],
    riskQuestion: [],
  },
  reasonToSelectProduct: [],
  vulnerableQuestions: [],
}

export const viewConfiguration = (state = initViewConfigurationState, action) => {
  switch (action.type) {
    case SET_VIEW_CONFIGURATION:
      return action.payload
  }
  return state
}

export const fnaConfiguration = (state = initFnaConfigurationState, action) => {
  switch (action.type) {
    case SET_FNA_CONFIGURATION:
      return action.payload
  }
  return state
}

export const allowedAgentTypes = (state = initAllowedAgentTypes, action) => {
  switch (action.type) {
    case SET_ALLOWED_AGENT_TYPES:
      return action.payload
  }
  return state
}
export const version = (state = initVersionState, action) => {
  switch (action.type) {
    case SET_VERSION:
      return action.payload
  }
  return state
}

const defaultProducts = {
  status: 'uninitialised',
  payload: [],
}

export const products = (state = defaultProducts, action) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
      return { ...state, status: 'fetching' }
    case GET_PRODUCTS_FAILED:
      return { ...state, status: 'error' }
    case GET_PRODUCTS_SUCCESS:
    case PATCH_PRODUCTS_SUCCESS:
      return { ...state, status: 'ready', payload: action.payload }
    default:
      return state
  }
}

const defaultRiders = {
  status: 'uninitialised',
  payload: [],
}

export const riders = (state = defaultRiders, action) => {
  switch (action.type) {
    case GET_RIDERS_REQUEST:
      return { ...state, status: 'fetching' }
    case GET_RIDERS_FAILED:
      return { ...state, status: 'error' }
    case GET_RIDERS_SUCCESS:
      return { ...state, status: 'ready', payload: action.payload }
    default:
      return state
  }
}

const defaultOccupations = {
  status: 'uninitialised',
  payload: [],
}

export const occupations = (state = defaultOccupations, action) => {
  switch (action.type) {
    case GET_OCCUPATIONS_REQUEST:
      return { ...state, status: 'fetching' }
    case GET_OCCUPATIONS_FAILED:
      return { ...state, status: 'error' }
    case GET_OCCUPATIONS_SUCCESS:
      return { ...state, status: 'ready', payload: action.payload }
    default:
      return state
  }
}

const defaultModelFactors = {
  status: 'uninitialised',
  payload: [],
}

export const modelFactors = (state = defaultModelFactors, action) => {
  switch (action.type) {
    case GET_MODEL_FACTORS_REQUEST:
      return { ...state, status: 'fetching' }
    case GET_MODEL_FACTORS_FAILED:
      return { ...state, status: 'error' }
    case GET_MODEL_FACTORS_SUCCESS:
      return { ...state, status: 'ready', payload: action.payload }
    default:
      return state
  }
}

export const pouchdb = (state = { status: 'uninitialised' }, action) => {
  switch (action.type) {
    case CONNECT_TO_DATABASE_REQUEST:
      return { status: 'replicating' }
    case CONNECT_TO_DATABASE_SUCCESS:
      return { status: 'ready' }
    case CONNECT_TO_DATABASE_FAILED:
      return { status: 'error' }
    default:
      return state
  }
}

const defaultDistributorGroups = {
  status: 'uninitialised',
  payload: [],
}

export const distributorGroups = (state = defaultDistributorGroups, action) => {
  switch (action.type) {
    case GET_DISTRIBUTOR_GROUPS_REQUEST:
      return { ...state, status: 'fetching' }
    case GET_DISTRIBUTOR_GROUPS_FAILED:
      return { ...state, status: 'error' }
    case GET_DISTRIBUTOR_GROUPS_SUCCESS:
      return { ...state, status: 'ready', payload: action.payload }
    default:
      return state
  }
}

export const status = (state = 'uninitialised', action) => {
  switch (action.type) {
    case INITIALISE_APPLICATION_REQUEST:
      return 'initialising'
    case INITIALISE_APPLICATION_FAILED_WITH_NO_INTERNET:
      return 'noInternet'
    case INITIALISE_APPLICATION_FAILED_WITH_UPDATE_APP:
      return 'updateApp'
    case INITIALISE_APPLICATION_FAILED_WITH_UPDATE_DATABASE:
      return 'updateDatabase'
    case INITIALISE_APPLICATION_SERVER_IS_DOWN:
      return 'serverIsDown'
    case APP_FAILED_SECURITY_POLICY:
      return 'failedSecurityPolicy'
    case GENERATE_PDF_REQUEST:
      return 'generatingPDF'
    case GENERATE_PDF_SUCCESS:
    case GENERATE_PDF_FAILURE:
    case SALE_PERMISSION_VALIDATION_COMPLETED:
    case INITIALISE_APPLICATION_SUCCESS:
      return 'ready'
    case VALIDATING_SALE_PERMISSION:
      return 'validatingSalePermission'
    default:
      return state
  }
}

export const isRemoteSelling = (state = false, action) => {
  switch (action.type) {
    case 'START_REMOTE_SELLING':
      return true
    case 'START_STANDARD_SELLING':
      return false
    default:
      return state
  }
}

export const selectedRemoteSelling = (state = false, action) => {
  switch (action.type) {
    case 'SET_SELECTED_REMOTE_SELLING':
      return true
    case 'RESET_SELECTED_REMOTE_SELLING':
      return false
    default:
      return state
  }
}

export const processing = (state = false, action) => {
  switch (action.type) {
    case PROCESSING_APP_DATA_REQUEST:
      return true
    case PROCESSING_APP_DATA_UNSET:
    case PROCESSING_APP_DATA_SUCCESS:
      return false
    default:
      return state
  }
}

const initSfReference = {
  startSaleFrom: 'AZ',
  accId: null,
  optyId: null,
}
export const sfReference = (state = initSfReference, action) => {
  switch (action.type) {
    case SF_REFERENCE:
      return action.payload
    case RESET_QUOTE_FORM:
      return initSfReference
    default:
      return state
  }
}

export const optyEntering = (state = {}, action) => {
  switch (action.type) {
    case ENTERING_IPRO:
      return action.payload
    case RESET_QUOTE_FORM:
      return {}
    default:
      return state
  }
}

const initialCloneAppList = { applicationList: [], policyList: [] }

export const cloneAppList = (state = initialCloneAppList, action) => {
  switch (action.type) {
    case CLONE_APP_LIST:
      return { ...initialCloneAppList, ...action.payload }
    case CLEAR_CLONE_APP_LIST:
    case RESET_QUOTE_FORM:
      return initialCloneAppList
    default:
      return state
  }
}

export const clonedAppId = (state = {}, action) => {
  switch (action.type) {
    case SET_CLONE_APP_ID:
      return action.payload
    case CLEAR_CLONE_APP_LIST:
    case RESET_QUOTE_FORM:
      return {}
    default:
      return state
  }
}

export const clonedPolicy = (state = null, action) => {
  switch (action.type) {
    case SET_CLONED_POLICY:
      return action.payload
    case CLEAR_CLONE_APP_LIST:
    case RESET_QUOTE_FORM:
      return null
    default:
      return state
  }
}

export const cloneAppSearchStatus = (state = [], action) => {
  switch (action.type) {
    case CLONE_APP_SEARCH_STATUS:
      return action.payload
    case CLEAR_CLONE_APP_SEARCH_STATUS:
    case RESET_QUOTE_FORM:
      return []
    default:
      return state
  }
}

export const enableMaPage = (state = false, action) => {
  switch (action.type) {
    case SET_ENABLE_MA_PAGE:
      return action.payload
    default:
      return state
  }
}

export const enableRetrieveCustomerPolicy = (state = false, action) => {
  switch (action.type) {
    case SET_ENABLE_RETRIEVE_CUSTOMER_POLICY:
      return action.payload
    default:
      return state
  }
}

const initWealthInfo = { dataSource: 'DEFAULT', isValidSalePermission: false, data: {} }

export const wealthInfo = (state = initWealthInfo, action) => {
  switch (action.type) {
    case UPDATE_WEALTH_SOURCE_DATA:
      return action.payload
    default:
      return state
  }
}

export const myWealthProfile = (state = {}, action) => {
  switch (action.type) {
    case INIT_CUSTOMER_PROFILE:
      return action.payload
    default:
      return state
  }
}

export const emptyDisplayProduct = {
  code: '',
  basicPlanCode: '',
  type: 'product',
  name: '',
  nameThai: '',
  displayName: '',
  basicPlanName: '',
  description: '',
  benefits: [],
  readOnlyFields: {},
  riders: [],
  image: '',
  category: 'WHOLE_LIFE',
  paymentPeriod: { type: 'by_package', value: -1 },
  coveragePeriod: { type: 'by_package', value: -1 },
  modelFactors: [],
  licenses: [],
  aura: undefined,
}

export const selectedDisplayProduct = (state = emptyDisplayProduct, action) => {
  switch (action.type) {
    case SELECT_PRODUCT:
    case SELECT_BASIC_PLAN:
    case UPDATE_SELECT_BASIC_PLAN:
    case IHEALTHY_ULTRA_SELECT_BASIC_PLAN:
    case EDIT_PERFECT_LIFE_PLAN:
    case EDIT_CAMPAIGN_PLAN:
    case CHANGE_PRODUCT:
      return action.payload
    case MRTA_UPDATE_CODE_IN_SELECTED_DISPLAY_PRODUCT:
      return {
        ...state,
        code: action.payload,
      }
    case MRTA_UPDATE_COVERAGE_PERIOD_IN_SELECTED_DISPLAY_PRODUCT:
      return {
        ...state,
        coveragePeriod: action.payload,
      }
    case RESET_QUOTE_FORM:
    case RESET_DISPLAY_PRODUCT:
      return emptyDisplayProduct
    default:
      return state
  }
}

const { DEFAULT_PRODUCT_CATEGORY } = constants
const initProductCategoryId = DEFAULT_PRODUCT_CATEGORY

export const selectedProductCategoryId = (state = initProductCategoryId, action) => {
  switch (action.type) {
    case SELECT_PRODUCT_CATEGORY:
      return action.payload
    case RESET_QUOTE_FORM:
      return initProductCategoryId
    default:
      return state
  }
}

const initProductSelection = {
  availableProductCategories: [],
  availablePlanCode: [],
}
export const productSelection = (state = initProductSelection, action) => {
  switch (action.type) {
    case AVAILABLE_PRODUCT_CATEGORIES:
      return set('availableProductCategories', action.payload)(state)
    case AVAILABLE_PLAN_CODE:
      return set('availablePlanCode', action.payload)(state)
    case RESET_QUOTE_FORM:
      return initProductSelection
    default:
      return state
  }
}

/**
 * @typedef {
 *  'update_birthdate' |
 *  'update_payer_birthdate' |
 *  'change_nature_of_duty'|
 *  'change_payer_need' |
 *  'change_payer_nature_of_duty' |
 *  'change_model_factor' |
 *  'change_product' |
 *  'change_basic_plan' |
 *  'change_sum_assured' |
 *  'change_premium' |
 *  'toggle_rider' |
 *  'change_rider_plan' |
 *  'change_pension_type' |
 *  'change_rider_sum_assured' |
 *  'change_regular_premium' |
 *  'change_regular_topup' |
 *  'change_lumpsum' |
 *  'change_loan_period' |
 *  'change_coverage_period' |
 *  'change_loan_amount' |
 *  'validate_interest_rate'
 * } TriggerBy
 */
/**
 * @type {{
 *  requesting: boolean,
 *  trigger_by: TriggerBy,
 *  availableDisplayProducts: Record
 *  availableRiders: Record<string>,
 *  e_submission: {
 *    kyc_question: any[]
 *  }
 * }}
 */
const initialApiState = {
  requesting: false,
  trigger_by: '',
  fetching_calculate: false,
  fetching_policy: false,
  canPackageProcess: true,
  currentSelectedProduct: {
    packageCategory: '',
    packageCode: '',
  },
  availableDisplayProducts: {},
  availableRiders: {},
  form_state: {
    dirty: false,
  },
  e_submission: {
    kyc_question: [],
  },
  seller_profile: undefined,
}
/** @type {Record<TriggerBy, number>} */
const triggerPriority = {
  '': -1,
  toggle_rider: 10,
  change_product: 10,
}
export const partner = (state = initialApiState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
      return initialApiState
    case 'PARTNER_UPDATE_FETCHING':
      return { ...state, ...action.payload }
    case 'PARTNER_API_REQUEST':
      if (get(triggerPriority, action.payload.trigger_by, 0) > get(triggerPriority, state.trigger_by, 0)) {
        return { ...state, ...action.payload, requesting: true }
      } else {
        return { ...state, requesting: true }
      }
    case 'PARTNER_API_SUCCESS':
    case 'PARTNER_API_FAILURE':
      return { ...state, trigger_by: '', requesting: false }
    case 'PARTNER_CALCULATION_FETCHING':
      return { ...state, fetching_calculate: true }
    case 'PARTNER_CALCULATION_FETCHED':
      return { ...state, fetching_calculate: false }
    case 'PARTNER_POLICY_FETCHING':
      return { ...state, fetching_policy: true }
    case 'PARTNER_POLICY_FETCHED':
      return { ...state, fetching_policy: false }
    case 'UPDATE_PACKAGE_CAN_PROCESS':
      return { ...state, canPackageProcess: action.payload }
    case 'UPDATE_CURRENT_SELECTED_PRODUCT':
      return set('currentSelectedProduct', action.payload)(state)
    case 'PATCH_AVAILABLE_DISPLAY_PRODUCTS':
      return set('availableDisplayProducts', action.payload)(state)
    case 'PATCH_AVAILABLE_RIDERS':
      return set('availableRiders', action.payload)(state)
    case 'UPDATE_KYC_QUESTION':
      return set('e_submission.kyc_question', action.payload)(state)
    case 'UPDATE_FORM_STATE':
      return set('form_state', action.payload)(state)
    case 'UPDATE_SELLER_PROFILE':
      return set('seller_profile', action.payload)(state)
    case 'RESET_SELLER_PROFILE':
      return set('seller_profile', {})(state)
    default:
      return state
  }
}

const _reducer = combineReducers({
  products,
  riders,
  occupations,
  modelFactors,
  viewConfiguration,
  selectedDisplayProduct,
  selectedProductCategoryId,
  productSelection,

  entryComponent,
  insured,
  coveragePlan,
  benefitIllustration,

  investment,
  loan,
  pouchdb,
  status,
  processing,
  version,
  allowedAgentTypes,
  identity,
  notificationMessage,
  distributorGroups,
  isRemoteSelling,
  selectedRemoteSelling,
  permissionOrdinary,
  appVersion,
  portal,
  fna,
  fnaConfiguration,
  ui,
  sfReference,
  optyEntering,
  wealthInfo,
  myWealthProfile,
  partner,
  cloneAppList,
  clonedAppId,
  clonedPolicy,
  cloneAppSearchStatus,
  enableMaPage,
  enableRetrieveCustomerPolicy,
})

export const reducer = (state, action) => {
  switch (action.type) {
    case 'LOAD_QUICK_QUOTE_STATE':
      const newState = Object.assign({}, state, action.payload)
      return _reducer(newState, action)
    default:
      return _reducer(state, action)
  }
}
